<ng-container *ngIf="event.scoreboard?.started && !penaltyShootout">
    <ms-set-game-scoreboard-header
        *ngIf="event.scoreboard.type === scoreboardType.SetGame"
        [scoreboard]="event.scoreboard"
        [hasExtended]="hasExtended"></ms-set-game-scoreboard-header>
    <ms-snooker-scoreboard-header *ngIf="event.scoreboard.type === scoreboardType.Snooker" [scoreboard]="event.scoreboard">
    </ms-snooker-scoreboard-header>
    <ms-darts-scoreboard-header *ngIf="event.scoreboard.type === scoreboardType.Darts" [scoreboard]="event.scoreboard" [hasExtended]="hasExtended">
    </ms-darts-scoreboard-header>
</ng-container>
